import React from 'react'
import intl from 'react-intl-universal'
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
} from 'reactstrap'

import { LineForm, useLineForm } from '../LineForm'
import { LineConfig } from '~/types'

// eslint-disable-next-line @typescript-eslint/no-var-requires
const styles = require('./LineConfigurationModal.styles.scss')

type LineConfigWithWebsite = LineConfig & { website: string }

interface Props {
  initialLineConfig: LineConfigWithWebsite
  toggle: () => void
  onSubmit: (config: LineConfigWithWebsite) => void
  websites: string[]
}

export default function LineConfigurationModal(props: Props) {
  const { website, ...fields } = props.initialLineConfig
  const mode = website ? 'edit' : 'add'

  const [selectedWebsite, setSelectedWebsite] = React.useState(website)
  const lineForm = useLineForm(fields)

  const handleSubmit = () => {
    const isValid = lineForm.validate()
    if (isValid) {
      props.onSubmit({
        website: selectedWebsite as string,
        ...lineForm.fields,
      })
      props.toggle()
    }
  }

  return (
    <Modal
      wrapClassName="bootstrap4"
      size="lg"
      className={styles.modal}
      centered
      isOpen
      toggle={props.toggle}
    >
      <ModalHeader>
        {mode === 'add'
          ? intl.get('LineConfigurationModal.headerAdd')
          : intl.get('LineConfigurationModal.headerEdit')}
      </ModalHeader>
      <ModalBody>
        <Label for="lineConfigSelectedWebsite">
          {intl.get('LineConfigurationModal.websiteLabel')}
        </Label>
        <Input
          type="select"
          id="lineConfigSelectedWebsite"
          className="input-primary"
          disabled={mode === 'edit'}
          value={selectedWebsite}
          onChange={(event) => {
            setSelectedWebsite(event.target.value)
          }}
        >
          <option value="" disabled>
            --
          </option>
          {props.websites.map((websiteName) => (
            <option key={websiteName} value={websiteName}>
              {websiteName}
            </option>
          ))}
        </Input>

        <LineForm {...lineForm} />
      </ModalBody>
      <ModalFooter>
        <Button
          color="secondary"
          className="btn-override-secondary"
          outline
          onClick={props.toggle}
        >
          {intl.get('LineConfigurationModal.buttonCancel')}
        </Button>
        <Button
          color="primary"
          className="btn-override-primary"
          disabled={!selectedWebsite}
          onClick={handleSubmit}
        >
          {mode === 'add'
            ? intl.get('LineConfigurationModal.buttonAdd')
            : intl.get('LineConfigurationModal.buttonEdit')}
        </Button>
      </ModalFooter>
    </Modal>
  )
}
